// extracted by mini-css-extract-plugin
module.exports = {"container":"IconButton_container__kWzsK","disabled":"IconButton_disabled__fmus7"};